import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
  IonButton,
  IonList,
  IonItem,
  IonInput,
  IonAlert,
  IonLoading
  } from '@ionic/react';
import React, {useState, useEffect} from 'react';
import './Login.css';
import ServerService from '../services/Server';

const Login: React.FC = () => {

const name:string = "Log In";

const server = new ServerService();
const state = server.accounts[server.activeAcc];
const [username, setUsername] = useState(state.username);
const [password, setPassword] = useState(state.password);

const [msg, setMsg] = useState("");
const [showMsg, setShowMsg] = useState(false);
const [showLoading, setShowLoading] = useState(false);

const loginCallback = (success:boolean, msg:string) => {
  setShowLoading(false);
  if (success) {
    setMsg("Login Successful");

    let i = server.activeAcc;
    
    server.saveLocal();

    window.location.href = "/page/home";
  } else {
    setMsg(msg);
  }
  setShowMsg(true);
}

return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <div className="center-container">
          <div className="icon-wrapper">
            <div className="icon-logout"></div>
          </div>
          
          <IonList>
  
            <IonItem>
              <IonInput label="User" value={username} required={true} onIonInput={(e: any) => setUsername(e.target.value)}>
              </IonInput>
            </IonItem>
  
            <IonItem>
              <IonInput label="Password" value={password} required={true} type="password" onIonInput={(e: any) => setPassword(e.target.value)}>
              </IonInput>
            </IonItem>
  
          </IonList>
          
          <IonButton
              className="btn-login"
              color="primary"
              size="large"
              onClick={(e) => {

                const i = server.activeAcc;

                server.accounts[i].username = username;
                server.accounts[i].password = password;

                setShowLoading(true);
                server.login(loginCallback);

              }}>
              Log In
          </IonButton>
        </div>

  <IonAlert
    isOpen={showMsg}
    onDidDismiss={e => {
      setShowLoading(false);
      setShowMsg(false);
    }}
    message={msg}
    buttons={['OK']}
  />
  <IonLoading 
    isOpen={showLoading}
    message={'Please wait...'}
  />        

      </IonContent>
    </IonPage>
    );
};

export default Login;
